import { Link } from "react-router-dom";
import PermissionGate from "../layout/PermissionGate";

const Actions = ({ id, status }) => {
  switch (status) {
    case "6":
    case "-2":
    case "-3":
      return (
        <PermissionGate required={`view_order_details`} fallback={<></>}>
          <div className="btn-group">
            {/*begin::View*/}
            <Link
              to={`/orders/order-details/${id}`}
              className="btn px-2 btn-outline btn-success btn-color-white btn-sm"
              title="Show Details"
            >
              <i className="bi-duotone bi-eye fs-5"></i>
              <span className="me-2">View</span>
            </Link>
            {/*end::View*/}
          </div>
        </PermissionGate>
      );
    default:
      return (
        <div className="btn-group">
          {/*begin::View*/}
          <PermissionGate required={`view_order_details`} fallback={<></>}>
            <Link
              to={`/orders/order-details/${id}`}
              className="btn px-2 btn-outline btn-success btn-color-white btn-sm"
              title="Show Details"
            >
              <i className="bi-duotone bi-eye fs-5"></i>
            </Link>
          </PermissionGate>
          {/*end::View*/}
          {/*begin::Edit*/}
          <PermissionGate required={`edit_order`} fallback={<></>}>
            <Link
              to={`/orders/edit-order/${id}`}
              className="btn px-2 btn-outline btn-primary btn-color-white btn-sm"
              title="Edit"
            >
              <i className="bi-duotone bi-pen fs-5"></i>
            </Link>
          </PermissionGate>
          {/*end::Edit*/}
        </div>
      );
  }
};

export default Actions;
